import { render } from "./paymentCard.vue?vue&type=template&id=564de56d&scoped=true"
import script from "./paymentCard.vue?vue&type=script&lang=js"
export * from "./paymentCard.vue?vue&type=script&lang=js"

import "./paymentCard.vue?vue&type=style&index=0&id=564de56d&scoped=true&lang=css"

import exportComponent from "F:\\CodeBrix\\My Porter\\WECCO-UserFlow\\MyPorter\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-564de56d"]])

export default __exports__